const mathEvaluationHelper = require('@cimpress-technology/math-evaluation-helper');
const math = require('../MathHelpers');
const Constants = require('./Constants');

/**
 * @param formula {string} - The formula string to check for variables.
 * @returns {boolean} - Whether the given formula string contains variables.
 */
function containsVariables(formula) {
  const formulaVariableRegex = new RegExp(mathEvaluationHelper.constants.VARIABLE_TOKEN_REGEX);

  return formulaVariableRegex.test(formula);
}

/**
 * Evaluates a formula using the set of variables.
 * @param formula {string} - The formula to evaluate.
 * @param variables {object} - A key-value dictionary of variables and values to use while calculating the formula.
 * @returns {number} - The value produced by calculating the formula.
 */
function evaluate(formula, variables) {
  const normalizedFormula = formula.toLowerCase();

  const formulaValue = mathEvaluationHelper.evaluate(normalizedFormula, variables);

  const roundedFormulaValue = math.round(formulaValue, Constants.MAXIMUM_DECIMAL_PRECISION);
  return roundedFormulaValue;
}

module.exports = {
  containsVariables,
  evaluate,
};
